export interface ReviewItem {
  id: string;
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export const reviews: ReviewItem[] = [
  {
    id: 'r1',
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20Asian%20man%20in%20warm%20lighting%2C%20friendly%20smile%2C%20clean%20background%2C%20minimalist%20style&width=160&height=160&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '用了福利视频在线快两年了，资源更新速度真的没话说！热门电影电视剧基本上首播后很快就能看到，画质也很清晰。重点是全程免费，简直是追剧神器！',
    date: '2025-03-20',
  },
  {
    id: 'r2',
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20Asian%20woman%20with%20warm%20natural%20lighting%2C%20gentle%20smile%2C%20simple%20neutral%20background%2C%20clean%20aesthetic&width=160&height=160&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '作为一个追剧达人，福利视频在线是我每天必逛的网站。分类特别清晰，想找什么类型的视频一目了然。短视频频道也很赞，无聊的时候刷刷特别解压。',
    date: '2025-03-18',
  },
  {
    id: 'r3',
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20student%20portrait%20in%20warm%20natural%20light%2C%20friendly%20expression%2C%20minimalist%20background%2C%20clean%20modern%20photography&width=160&height=160&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '大学生一枚，福利视频在线的纪录片和教育频道对我的学习帮助很大。很多高质量的科普纪录片在其他平台都要付费，这里全部免费看！良心平台必须好评！',
    date: '2025-03-15',
  },
  {
    id: 'r4',
    name: '赵先生',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20portrait%20with%20warm%20studio%20lighting%2C%20confident%20professional%20look%2C%20clean%20neutral%20background%2C%20modern%20corporate%20photography&width=160&height=160&seq=avatar-04&orientation=squarish',
    rating: 4,
    content: '体育迷的福音！NBA和足球赛事的回放更新非常及时，画质也够清晰。半夜看球不方便的时候，第二天来这里看回放简直完美。希望能增加更多赛事直播功能。',
    date: '2025-03-12',
  },
  {
    id: 'r5',
    name: '陈女士',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20woman%20portrait%20with%20soft%20warm%20lighting%2C%20relaxed%20friendly%20expression%2C%20simple%20cream%20background%2C%20natural%20beauty%20photography&width=160&height=160&seq=avatar-05&orientation=squarish',
    rating: 5,
    content: '我的宝宝特别喜欢看动漫频道，这里的动漫资源真的很全，而且全部免费。作为家长也不用担心付费问题，孩子想看什么都能找到。感谢福利视频在线！',
    date: '2025-03-10',
  },
  {
    id: 'r6',
    name: '刘先生',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20man%20portrait%20in%20warm%20cozy%20lighting%2C%20casual%20friendly%20smile%2C%20minimalist%20background%2C%20approachable%20modern%20photography&width=160&height=160&seq=avatar-06&orientation=squarish',
    rating: 5,
    content: '推荐给身边很多朋友了，大家都说好用。页面简洁没有乱七八糟的广告，这点特别加分！视频加载速度也很快，用手机流量看也不怎么卡。',
    date: '2025-03-08',
  },
];